module.exports = "/assets/0826238de4cc96ce17cbfa74536f145a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/6B.png
// module id = 1079
// module chunks = 0